export default __webpack_public_path__ + "static/media/withdraw.0e23f65f.svg";